import React from 'react';
import divider from '../assets/divider.png';
import location1 from '../assets/location1.jpg';
import location2 from '../assets/location2.jpg';
import location3 from '../assets/location3.jpg';
import location4 from '../assets/location4.png';
import Help from './help';
import { Container } from 'react-bootstrap';

const En = () => {

    return (
        <>
            <Help lang='en' />
            <section>
                <Container className='section'>
                    <div className='instructions'>
                        <h1>SPRING ALLEYCAT RACE</h1>
                        <h2>INSTRUCTIONS</h2>
                        <img className='divider' src={divider} alt='Divider' />
                        <p>
                            🌟 Visit all 4 challenge locations listed on this card.
                            <br />
                            🔁 You can visit the locations in any order.
                            <br />
                            📱 You may use your mobile device to help find the locations and map a safe route.
                            <br />
                            🧩 At each location, you'll complete a unique challenge. All team members must be present.
                            <br />
                            🎟️ After completing each challenge, you'll receive a token.
                            <br />
                            🏃‍♂️ Once your team has collected all 3 tokens, race back to Bobino Bagel to cross the finish line!
                            <br />
                            ⏱️ The first team where all 4 members return with every token wins the race!
                        </p>
                    </div>
                </Container>
            </section>
            <div className='location'>
                <img className='location-img' src={location1} alt='Location #1' />
                <div className='location-desc'>
                    <Container className='section'>
                        <h3>Location #1</h3>
                        <p>
                            Across the bridge along the water, find the club where members row, row, row their boats, gently down the river. Your challenge awaits on the main road inland.
                        </p>
                    </Container>
                </div>
            </div>
            <div className='location'>
                <img className='location-img' src={location2} alt='Location #2' />
                <div className='location-desc'>
                    <Container className='section'>
                        <h3>Location #2</h3>
                        <p>
                            Your next challenge awaits in the flats before the place that honours those who served.
                        </p>
                    </Container>
                </div>
            </div>
            <div className='location'>
                <img className='location-img' src={location3} alt='Location #3' />
                <div className='location-desc'>
                    <Container className='section'>
                        <h3>Location #3</h3>
                        <p>
                            Where Hull's nightlife lives, filled with patios, music, and energy, find the square where the city comes alive.
                        </p>
                    </Container>
                </div>
            </div>
            <div className='location'>
                <img className='location-img' src={location4} alt='Location #4' />
                <div className='location-desc'>
                    <Container className='section'>
                        <h3>Location #4</h3>
                        <p>
                            In a park in Hull along the river, find one of the region's oldest homes, open as a summer restaurant with a view of Parliament.
                        </p>
                    </Container>
                </div>
            </div>
            <Help lang='en' />
        </>
    )
}

export default En